<template>
    <div id="distributed_response">
        <div v-if="distributed_to.message" class="distributed_to_message"
            :style="{
                borderColor: border_color()
            }">

            <h3>
                <!-- 分撥結果： -->
                {{ $t('ui.scanner.helps.distributed_result') }}：
                {{ distributed_to.message }}
            </h3>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    props: {
        is_inverted: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
        }
    },
    computed: {
        current_store() {
            return this.$store.state.customer.scanner_module
        },
        settings() {
            return this.current_store.settings
        },
        distributed_to() {
            return this.current_store.distributed_to
        },
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        border_color() {
            if (this.distributed_to.status != "success") {
                return 'red'
            } else {
                switch (this.distributed_to.type) {
                    // "direct": 表示運單應在當前站點直接派送
                    case "direct":
                        return 'green'
                        break

                    // "transfer": 表示運單應中轉至object提示之站點
                    case "transfer":
                        return 'green'
                        break

                    // "intermodal": 表示運單應聯運至object提示之對象
                    case "intermodal":
                        return 'green'

                        break
                    default:
                        return 'green'

                }
            }

        },
    },

}
</script>

<style lang="scss" scoped>
    #distributed_response {
        .distributed_to_message {
            border-bottom: 3px solid;
            margin-bottom: 6px;
        }
    }
</style>
